import React from "react";

import Backend from "../../utils/Backend";
import Image from "../blocks/editable/Image";

export default class Assets extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      assets: []
    };
  }

  componentDidMount(){
    this._loadAssets()
  }

  _loadAssets(){
    let {

    } = this.state

    this.setState({ loading: true })

    Backend.getAssets().then(assets => {
      let data = assets
      if (this.props.svgOnly) {
        data = assets?.filter((o) => o?.toLowerCase()?.endsWith(".svg"))
      }
      this.setState({assets: data})
    })
  }

  render() {
    let {
      assets
    } = this.state

    return (
      <>
        <div
          className={"row box-images mx-0"}
        >
          {
            assets?.map(asset => {
              let assetData = {
                banner: asset,
                thumbnail: asset,
                original: asset,
              }
              return (
                <div className="col-md-4 mb-3 tile-img">
                  <Image
                    className={`image-search-thumbnail ${this.props.svgOnly ? "image-search-thumbnail-contain" : ""}`}
                    src={asset}
                    type={this.props.type}
                    primaryColor={this.props.primaryColor}
                    onClick={() => this.props.onSelected(assetData)}
                  />
                </div>
              )
            })
          }
        </div>
      </>
    )
  }

}
